import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

// 🗃️ Mise en cache des requêtes GET
@Injectable()
export class CacheInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    function isIE() {
      const ua = window.navigator.userAgent; // Check the userAgent property of the window.navigator object
      const msie = ua.indexOf('MSIE '); // IE 10 or older
      const trident = ua.indexOf('Trident/'); // IE 11
      return msie > 0 || trident > 0;
    }

    if (isIE() && !request.url.includes(environment.baseFileUrl)) {
      request = request.clone({
        headers: request.headers
          .set('Cache-Control', 'no-cache')
          .set('Pragma', 'no-cache')
          .set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT')
          .set('If-Modified-Since', '0'),
      });
    }

    return next.handle(request);
  }
}
